import { useEffect, useRef, useState } from "react";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  SortEnd,
} from "react-sortable-hoc";
import IconDragVertical from "../../assets/images/icons/drag_vertical.svg";

const moveArray = <T,>(arr: T[], fromIndex: number, toIndex: number): T[] => {
  const newArr = [...arr];
  const [movedItem] = newArr.splice(fromIndex, 1);
  newArr.splice(toIndex, 0, movedItem);
  return newArr;
};

interface Item {
  id: string;
  text: string;
}

const DragHandle = SortableHandle(() => (
  <div
    style={{
      padding: "10px",
      paddingRight: "0",
      cursor: "move",
    }}
  >
    <img
      alt="iconMenu"
      src={IconDragVertical}
      style={{ height: "20px", stroke: "#fff" }}
    />
  </div>
));

const SortableItem = SortableElement<{ value: string; onChecked: any }>(
  ({ value, onChecked }: any) => (
    <div
      className="user-select-none d-flex"
      style={{
        // padding: "10px",
        background: value?.checked ? "#007bff" : "#fff",
        color: value?.checked ? "#fff" : "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "5px",
        textAlign: "center",
        margin: "0 10px",
        border: "1px solid #ddd",
        borderColor: "#007bff",
      }}
    >
      <DragHandle />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "2px",
          padding: "0 10px",
          height: "100%",
          cursor: "pointer",
        }}
        onClick={() => {
          onChecked(!value?.checked);
        }}
      >
        <img
          alt="iconMenu"
          src={!value?.checked ? value?.icon : value?.iconEnable}
          style={{ height: "20px", stroke: "red" }}
        />
        <p style={{ margin: 0 }}>{value?.text}</p>
      </div>
    </div>
  )
);

const SortableList = SortableContainer<{ items: Item[]; handleChecked: any }>(
  ({ items, handleChecked }: any) => (
    <ul
      style={{
        display: "flex",
        padding: "10px 0px",
        listStyle: "none",
        overflowX: "auto",
        whiteSpace: "nowrap",
      }}
    >
      {items.map((item: any, index: any) => (
        <SortableItem
          key={item.id}
          index={index}
          value={item}
          onChecked={handleChecked(item?.id)}
        />
      ))}
    </ul>
  )
);

const DragMenu = ({ menuList, onChange }: any) => {
  const [data, setData] = useState<Item[]>(menuList);
  const ref = useRef<any>();
  const onSortEnd = ({ oldIndex, newIndex }: SortEnd) => {
    setData((prevData) => {
      const temp = moveArray(prevData, oldIndex, newIndex);

      onChange(temp);
      return temp;
    });
  };

  const handleChecked = (id: any) => (event: any) => {
    const tempArr = [...data];
    const temp = tempArr.map((i: any) => {
      if (i.id === id) {
        i.checked = event;
      }
      return i;
    });
    onChange(temp);
    setData(temp);
  };

  useEffect(() => {
    setData(menuList);
  }, [menuList]);

  return (
    <SortableList
      ref={ref}
      items={data}
      onSortEnd={onSortEnd}
      axis="x"
      useDragHandle
      handleChecked={handleChecked}
    />
  );
};

export default DragMenu;
